"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NOTIFIER_URL = exports.NOTIFIER_VERSION = exports.NOTIFIER_NAME = void 0;
exports.NOTIFIER_NAME = 'airbrake-js/browser';
exports.NOTIFIER_VERSION = '2.1.8';
exports.NOTIFIER_URL = 'https://github.com/airbrake/airbrake-js/tree/master/packages/browser';
//# sourceMappingURL=version.js.map